// This file generates a code that can be used in OAuth flows, such as PKCE (Proof Key for Code Exchange).
export async function generateRandomCode(length: number = 32) {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return String.fromCharCode.apply(null, Array.from(array));
}
